import React from "react";
import { MainLayout } from "./MainLayout";

export const AuthorizationController: React.FC = (): React.ReactElement => (
  <MainLayout />
);
